import apiClient, { getApiErrorMessage } from "../../api/client";
import {
  SET_APP_LOADING_FALSE,
  SET_APP_LOADING_TRUE,
  SET_DELETE_USER_LOADING_FALSE,
  SET_DELETE_USER_LOADING_TRUE,
  SET_USER_AFTER_LOGIN,
  SET_USER_AFTER_LOGOUT,
  SET_USER_AFTER_REFRESH,
  SET_USER_LOGIN_LOADING_FALSE,
  SET_USER_LOGIN_LOADING_TRUE,
} from "../constants/UserConstants";

export const loginUserAction =
  ({ email, password }, toast, navigate) =>
  async (dispatch) => {
    try {
      dispatch({ type: SET_USER_LOGIN_LOADING_TRUE });
      const loginApiRequest = await apiClient.post("/user/login", {
        email,
        password,
      });
      const loginApiResponse = loginApiRequest.data;
      if (loginApiResponse?.type === "error") {
        const message = loginApiResponse?.message || "Login failed";
        toast.error(message, { id: 2 });
        return { ok: false, message };
      }

      dispatch({
        type: SET_USER_AFTER_LOGIN,
        payload: {
          token: loginApiResponse?.token,
          user: loginApiResponse?.user,
        },
      });
      navigate("/");
      return { ok: true };
    } catch (error) {
      const message = getApiErrorMessage(error);
      toast.error(message, { id: 2 });
      return { ok: false, message };
    } finally {
      dispatch({ type: SET_USER_LOGIN_LOADING_FALSE });
    }
  };

export const getUserOnRefresh = (token, toast) => async (dispatch) => {
  try {
    dispatch({ type: SET_APP_LOADING_TRUE });
    const getUserRequest = await apiClient.get("/user/get/user", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const getUserResponse = getUserRequest.data;

    if (getUserResponse?.type === "error") {
      toast.error(getUserResponse?.message || "Unable to load user", { id: 1 });
      dispatch({ type: SET_USER_AFTER_LOGOUT });
    } else {
      dispatch({ type: SET_USER_AFTER_REFRESH, payload: getUserResponse.user });
    }
  } catch (error) {
    const message = getApiErrorMessage(error);
    toast.error(message, { id: 1 });
    if (error?.response?.status === 401) {
      dispatch({ type: SET_USER_AFTER_LOGOUT });
    }
  } finally {
    dispatch({ type: SET_APP_LOADING_FALSE });
  }
};

export const deleteUserAPIAction = (toast, navigate) => async (dispatch) => {
  try {
    const token = localStorage.getItem("Appusertoken");
    if (!token) {
      const findButton = document.getElementById("modelForDeleteUserButton");
      findButton?.click();
      dispatch({ type: SET_USER_AFTER_LOGOUT });
      navigate("/login");
    } else {
      dispatch({ type: SET_DELETE_USER_LOADING_TRUE });
      const apiRequest = await apiClient.post(
        "/user/delete/user",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const apiData = apiRequest.data;
      if (apiData?.type === "error") {
        if (apiData?.status === 401) {
          const findButton = document.getElementById("modelForDeleteUserButton");
          findButton?.click();
          toast.error(apiData?.message, { id: 1 });
          dispatch({ type: SET_USER_AFTER_LOGOUT });
        } else {
          toast.error(apiData?.message, { id: 4 });
        }
      }

      if (apiData?.type === "success") {
        toast.success(apiData?.message, { id: 3 });
        const findButton = document.getElementById("modelForDeleteUserButton");
        findButton?.click();
        navigate("/user/deleted");
        setTimeout(() => {
          dispatch({ type: SET_USER_AFTER_LOGOUT });
        }, 5000);
      }
    }
  } catch (error) {
    const message = getApiErrorMessage(error);
    if (error?.response?.status === 401) {
      dispatch({ type: SET_USER_AFTER_LOGOUT });
      navigate("/login");
    }
    toast.error(message, { id: 4 });
  } finally {
    dispatch({ type: SET_DELETE_USER_LOADING_FALSE });
  }
};
